/* eslint-disable import/prefer-default-export */
import SLICE from './_create.slice';

export const { ROOT_SLICE } = SLICE;